export default __webpack_public_path__ + "static/media/burgerProject.cfb9f87f.jpg";